module.exports = __webpack_public_path__ + "static/media/barcode.bb9227b6.svg";